import React from 'react';
import { useAppSelector } from 'hooks/redux';
import { formatNumber } from 'store/actions/mainPage/constant';
import { Box, Typography } from '@mui/material';
import { FixedSizeList as List } from 'react-window';
import { LanguageService } from 'services/languageService';

const Row = ({ data, index, style }) => {
  const item = data.data[index];
  const unit = data.export.unit || item.unit;
  const lang = LanguageService.getLanguage();
  return (
    <Box
      style={{
        ...style,
        display: 'flex',
        padding: '0 8px',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            width: '16px',
            height: '16px',
            mr: 1,
            backgroundColor: item.color,
            border: '1px solid black',
          }}
        />
        <Typography sx={{ textAlign: 'left', lineHeight: '1.1' }}>
          {item.paramName}
        </Typography>
      </Box>
      <Typography sx={{ textAlign: 'right', lineHeight: '1.1' }}>
        {formatNumber(item.paramValue, lang)} {unit}
      </Typography>
    </Box>
  );
};

export const PieData: React.FC = () => {
  const { statisticsData } = useAppSelector((state) => state.mainPage);
  if (!statisticsData) {
    return null;
  }
  const { data } = statisticsData;
  const itemHeight = 35;
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <List
        height={window.innerHeight - 440}
        itemCount={data.length}
        itemSize={itemHeight}
        width="100%"
        itemData={statisticsData}
        style={{
          maxHeight: 'calc(100vh - 785px)',
          overflow: 'auto',
          flex: 1,
        }}
      >
        {Row}
      </List>
    </Box>
  );
};
